var _rect, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _polygon3, _path7, _path8, _path9, _path10, _path11, _path12, _polygon4, _path13, _polygon5, _path14, _path15, _path16, _polygon6, _polygon7, _polygon8, _path17, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _path18, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _path19, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1791.999,
    height: 1791.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 47413.32 47413.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47413.32,
    height: 47413.32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M26250.62 5775.86c0,1668.6 -1185.51,3020.7 -2647.26,3020.7 -1461.76,0 -2645.89,-1352.1 -2645.89,-3020.7 0,-1667.21 1184.13,-3019.28 2645.89,-3019.28 1461.75,0 2647.26,1352.07 2647.26,3019.28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#664624",
    fillRule: "nonzero",
    d: "M23603.37 12395.82c1393.73,0 1013.38,-692.68 1211.89,-1098.87l-316.54 -1973.03 -1799.05 0c0,0 -256.81,1516.18 -316.53,1978.29 145.78,433.8 -174.88,1093.61 1220.23,1093.61z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#815932",
    fillRule: "nonzero",
    d: "M26074.33 6540.77c0,1899.03 -434.53,3938.26 -2473.76,3938.26 -2039.24,0 -2473.73,-2039.23 -2473.73,-3938.26 0,-1899.03 1073.07,-2694.48 2440.42,-2694.48 1365.98,0 2507.07,795.45 2507.07,2694.48z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#815932",
    fillRule: "nonzero",
    d: "M21747.35 7187.65c0 390.09-277.62 705.18-619.12 705.18-341.5 0-619.12-315.09-619.12-705.18 0-390.07 277.62-706.6 619.12-706.6 341.5 0 619.12 316.53 619.12 706.6zM26721.2 7187.65c0 390.09-277.61 705.18-620.49 705.18-342.88 0-620.54-315.09-620.54-705.18 0-390.07 277.66-706.6 620.54-706.6 342.88 0 620.49 316.53 620.49 706.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d744b",
    fillRule: "nonzero",
    d: "M22960.62 7061.32l-1188.27 0c-183.25 0-331.79-148.54-331.79-330.38l0-498.37c0-181.84 148.54-330.38 331.79-330.38l1188.27 0c183.25 0 331.79 148.54 331.79 330.38l0 498.37c0 181.84-148.54 330.38-331.79 330.38zM25428.83 7061.32l-1189.68 0c-183.26 0-330.38-148.54-330.38-330.38l0-498.37c0-181.84 147.12-330.38 330.38-330.38l1189.68 0c180.46 0 330.37 148.54 330.37 330.38l0 498.37c0 181.84-149.91 330.38-330.37 330.38z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M21772.35 5995.21c-131.87 0-238.77 106.87-238.77 238.77l0 495.55c0 131.9 106.9 238.77 238.77 238.77l1188.27 0c131.91 0 238.77-106.87 238.77-238.77l0-495.55c0-131.9-106.86-238.77-238.77-238.77l-1188.27 0zm1188.27 1159.13l-1188.27 0c-234.6 0-424.77-190.21-424.77-424.81l0-495.55c0-234.6 190.17-424.81 424.77-424.81l1188.27 0c234.6 0 424.81 190.21 424.81 424.81l0 495.55c0 234.6-190.21 424.81-424.81 424.81zM24239.15 5995.21c-131.87 0-238.77 106.87-238.77 238.77l0 495.55c0 131.9 106.9 238.77 238.77 238.77l1189.68 0c129.07 0 237.35-106.87 237.35-238.77l0-495.55c0-131.9-108.28-238.77-237.35-238.77l-1189.68 0zm1189.68 1159.13l-1189.68 0c-233.23 0-424.78-190.21-424.78-424.81l0-495.55c0-234.6 191.55-424.81 424.78-424.81l1189.68 0c233.18 0 423.4 190.21 423.4 424.81l0 495.55c0 234.6-190.22 424.81-423.4 424.81z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "23385.43 6503.26 23908.26 6503.26 23908.26 6317 23385.43 6317"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "26181.23 6507.43 25743.95 6526.89 25774.46 6343.64 26202.03 6332.51"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "21044.96 6507.43 21482.24 6526.89 21451.69 6343.64 21004.7 6332.51"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M22563.6 6456.08c0 97.15-79.11 176.3-176.29 176.3-97.16 0-176.3-79.15-176.3-176.3 0-97.19 79.14-176.3 176.3-176.3 97.18 0 176.29 79.11 176.29 176.3zM25008.18 6456.08c0 97.15-77.73 176.3-174.88 176.3-97.19 0-176.3-79.15-176.3-176.3 0-97.19 79.11-176.3 176.3-176.3 97.15 0 174.88 79.11 174.88 176.3zM24494.58 9175.93c0 290.55-237.39 528.34-528.92 528.34l-702.39 0c-290.16 0-527.51-237.79-527.51-528.34l0-480.73c0-290.12 527.51-528.89 527.51-528.89l702.39 0c0 0 528.92 238.77 528.92 528.89l0 480.73zm-440.07-1313.61l-880.1 0c0 0-838.46 376.18-838.46 837.05l0 941.74c0 460.87 377.59 837.92 838.46 837.92l880.1 0c462.25 0 839.85-377.05 839.85-837.92l0-941.74c0-460.87-839.85-837.05-839.85-837.05z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M24271.07 8556.41c0,0 -295.7,480.29 -658,480.29 -365.1,0 -659.38,-480.29 -659.38,-480.29l1317.38 0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e7dac",
    fillRule: "nonzero",
    d: "M23601.99 4250.26c1206.31,0 1524.23,630.21 2630.6,1428.42 112.44,-302.62 108.27,-2164.15 -398.4,-2670.86 -506.71,-509.46 -1760.24,-948.12 -2232.2,-948.12 -473.37,0 -1756.07,452.53 -2265.54,980.05 -487.25,503.92 -478.91,2330.76 -366.47,2633.38 964.79,-824.59 1424.28,-1422.87 2632.01,-1422.87z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#18658c",
    fillRule: "nonzero",
    d: "M23608.91 4126.69c-4.17,0 -5.54,0 -9.71,0 -2.79,0 -6.92,0 -9.71,0 -1450.67,0 -2046.19,860.68 -2625.05,1546.44 1043.89,297.08 1286.83,-1291 2597.29,-1310.42 0,0 24.97,1.37 37.47,0 12.5,1.37 37.47,0 37.47,0 1310.46,19.42 1553.4,1607.5 2598.71,1310.42 -580.28,-685.76 -1175.81,-1546.44 -2626.47,-1546.44z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e7dac",
    fillRule: "nonzero",
    d: "M23817.12 2141.6l-435.86 0c-72.19,0 -133.29,-61.06 -133.29,-134.66l0 0c0,-73.56 61.1,-133.25 133.29,-133.25l435.86 0c73.6,0 133.28,59.69 133.28,133.25l0 0c0,73.6 -59.68,134.66 -133.28,134.66z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#664624",
    fillRule: "nonzero",
    d: "M22713.55 45539.62l0 -1343.87 -2148.92 0c0,0 -1674.14,-131.33 -1917.08,262.07 -137.41,225.58 -86.07,1081.8 -86.07,1081.8l4152.07 0z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#9d764b",
    fillRule: "nonzero",
    points: "18550.4 45533.1 22719.17 45533.1 22719.17 45192.28 18550.4 45192.28"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#664624",
    fillRule: "nonzero",
    d: "M24487.63 45539.62l0 -1343.87 2147.51 0c0,0 1675.55,-131.33 1918.49,262.07 138.79,225.58 86.06,1081.8 86.06,1081.8l-4152.06 0z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#9d764b",
    fillRule: "nonzero",
    points: "24482.08 45533.1 28650.93 45533.1 28650.93 45192.28 24482.08 45192.28"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e7dac",
    fillRule: "nonzero",
    d: "M27425.01 24427.2l1173.01-46.24 1446.5-5847.7c0 0-502.51-2677.41-1245.2-4634.31-449.78-1187.04-806.54-2244.02-1295.17-2244.02-1292.41 0-959.24 551.83-959.24 551.83-315.13 85.77 266.52 2070.04 324.83 2431.8l1264.66 3894.7-709.39 5893.94zM19762.25 24427.2l-1173.01-46.24-1446.46-5847.7c0 0 502.51-2677.41 1245.2-4634.31 449.74-1187.04 806.5-2244.02 1295.17-2244.02 1292.37 0 960.62 551.83 960.62 551.83 313.71 85.77-267.94 2070.04-326.25 2431.8l-1264.62 3894.7 709.35 5893.94z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#132e42",
    fillRule: "nonzero",
    d: "M19902.46 23427.31c0,0 -187.39,4756.18 -187.39,6119.8 0,1363.58 559.44,14652.09 559.44,14652.09l2439.04 0 782.92 -15901.89 217.96 0 774.58 15901.89 2437.67 0c0,0 558.06,-13186.89 558.06,-14591.17 0,-1404.28 -186.04,-6180.72 -186.04,-6180.72l-7396.24 0z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M25012.35 14751.99l-2731.92 0 0 -3182.13c0,0 465.04,671.48 1313.21,671.48 848.18,0 1418.71,-795.6 1418.71,-795.6l0 3306.25z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#664624",
    fillRule: "nonzero",
    points: "27304.27 23427.31 19901.08 23427.31 19867.78 24365.96 27334.78 24365.96"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#132e42",
    fillRule: "nonzero",
    points: "25226.15 24365.96 25558.48 24365.96 25558.48 23427.27 25226.15 23427.27"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#132e42",
    fillRule: "nonzero",
    points: "21652.99 24365.96 21984.02 24365.96 21984.02 23427.27 21652.99 23427.27"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e7dac",
    fillRule: "nonzero",
    d: "M27562.46 11660.63c-249.9,-83.27 -2911.04,-340.38 -2911.04,-340.38l-1086.95 3380.1 -1057.77 -3380.1c0,0 -2652.81,257.11 -2904.08,340.38 297.07,279.61 335.92,989.36 299.83,1820.62 -44.39,1022.8 -19.43,9946.06 -19.43,9946.06l7403.2 0c0,0 -15.29,-9163.69 -31.96,-10186.79 -15.26,-832.05 11.12,-1300.28 308.2,-1579.89z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0f5070",
    fillRule: "nonzero",
    points: "23582.53 14700.35 22455.32 10881.05 22567.77 12876.01"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#155f84",
    fillRule: "nonzero",
    points: "21448.9 13430.84 22567.77 12876.01 22455.32 10881.05 21590.51 11414.51"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0f5070",
    fillRule: "nonzero",
    points: "23582.53 14700.35 24709.73 10881.05 24595.9 12876.01"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#155f84",
    fillRule: "nonzero",
    points: "25717.57 13430.84 24595.9 12876.01 24709.73 10881.05 25574.57 11414.51"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#155f84",
    fillRule: "nonzero",
    points: "22878.72 15559.22 21697.38 15822.7 20517.45 15559.22 20517.45 14892.74 22878.72 14892.74"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M21822.32 15481.63c0,68.42 -55.51,123.94 -124.94,123.94 -66.61,0 -123.54,-55.52 -123.54,-123.94 0,-68.45 56.93,-123.97 123.54,-123.97 69.43,0 124.94,55.52 124.94,123.97z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    fillRule: "nonzero",
    points: "26637.93 16008.02 24276.61 16008.02 24276.61 14721.73 26637.93 14721.73"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#bdbdbd",
    fillRule: "nonzero",
    points: "25338.59 14722.85 25338.59 14554.31 25249.74 14722.85"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d9d9d9",
    fillRule: "nonzero",
    points: "25338.59 14891.5 25575.08 14891.5 25575.08 14554.42 25338.59 14554.42"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d9d9d9",
    fillRule: "nonzero",
    points: "25249.74 15294.21 26418.18 15294.21 26418.18 15185.54 25249.74 15185.54"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d9d9d9",
    fillRule: "nonzero",
    points: "25249.74 15651.26 26418.18 15651.26 26418.18 15542.48 25249.74 15542.48"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d9d9d9",
    fillRule: "nonzero",
    points: "24443.2 15794.36 25156.54 15794.36 25156.54 15046.38 24443.2 15046.38"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0a4f6f",
    fillRule: "nonzero",
    points: "19970.48 42678.44 22788.49 42678.44 22713.55 44199.19 19902.46 44199.19"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#0a4f6f",
    fillRule: "nonzero",
    points: "24414.06 42678.44 27207.08 42678.44 27291.76 44199.19 24482.08 44199.19"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#0a4f6f",
    fillRule: "nonzero",
    d: "M27415.3 26707.12c-36.09-4.27-907.86-117.41-1421.49-957.14-398.4-649.81-358.14-1354.16-356.76-1384.02l259.57 0c0 6.52-47.19 674.38 308.2 1254.8 449.74 734.35 1195.22 836.22 1202.14 837.19l8.34 249.17zM19787.26 26707.12c36.09-4.27 907.86-117.41 1422.87-957.14 397.02-649.81 356.76-1354.16 355.38-1384.02l-258.19 0c0 6.52 45.8 674.38-309.58 1254.8-449.75 734.35-1193.81 836.22-1202.15 837.19l-8.33 249.17zM23808.82 27125.96c-197.13 0-531.67-31.38-778.78-218.22-284.57-215.44-248.48-1853.09-219.34-2541.78l242.93 2.1c-40.26 1011.28-2.79 2207.88 129.12 2344.06 197.09 150.35 490 168 649.66 165.76l0-2509.82 248.49 0 0 2737.06-109.66 13.05c-6.96.72-69.43 7.79-162.42 7.79z"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d6b792",
    fillRule: "nonzero",
    points: "23186.92 24460.65 23406.81 24460.65 23406.81 23334.65 23186.92 23334.65"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d6b792",
    fillRule: "nonzero",
    points: "23375.69 24460.65 24032.81 24460.65 24032.81 24368.1 23375.69 24368.1"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#9d764b",
    fillRule: "nonzero",
    points: "23250.77 23944.8 23629.17 23944.8 23629.17 23839.5 23250.77 23839.5"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d6b792",
    fillRule: "nonzero",
    points: "23375.69 23427.31 24032.81 23427.31 24032.81 23334.72 23375.69 23334.72"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#cf9e5f",
    fillRule: "nonzero",
    points: "17212.18 25394.6 29951.28 25394.6 29951.28 23998.73 17212.18 23998.73"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#cf9e5f",
    fillRule: "nonzero",
    points: "16717.97 22625.62 29455.73 22625.62 29455.73 21229.89 16717.97 21229.89"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#cf9e5f",
    fillRule: "nonzero",
    points: "17956.24 19856.89 30695.34 19856.89 30695.34 18461.02 17956.24 18461.02"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d6b792",
    fillRule: "nonzero",
    points: "17419.02 24010.18 30158.12 24010.18 30158.12 22614.32 17419.02 22614.32"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d6b792",
    fillRule: "nonzero",
    points: "17130.28 21241.31 29869.34 21241.31 29869.34 19845.51 17130.28 19845.51"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#815932",
    fillRule: "nonzero",
    d: "M20595.18 25565.93c0 0 303.99-362.49-106.91-648.58-302.62-18.88-635.78 23.05-669.09 81.35-179.08 316.25-513.63 390.21-513.63 390.21 0 0 62.48 183.4 417.86 252.79 262.36 51.24 871.77-75.77 871.77-75.77zM26537.99 25565.93c0 0-302.62-362.49 105.48-648.58 305.41-18.88 637.17 23.05 670.51 81.35 179.05 316.25 513.63 390.21 513.63 390.21 0 0-62.47 183.4-417.86 252.79-263.77 51.24-871.76-75.77-871.76-75.77z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.9da741c860ce9b89273dc42e4b08d692.svg";
export { ForwardRef as ReactComponent };